import { FC, ReactNode } from 'react';
import styled from 'styled-components';

import LoadingSpinner, { loadingSpinnerColors } from '~src/shared/loadingSpinner/LoadingSpinner';

export const LoaderWrapper = styled.div`
  &.loading {
    > button {
      cursor: auto;
      &::before {
        opacity: 0.15;
      }
    }
  }
`;

const ContentWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SpinnerContainer = styled.div<{ $show?: boolean }>`
  position: absolute;
  display: ${({ $show }) => ($show ? 'block' : 'none')};
`;

const TextContainer = styled.div<{ $show: boolean }>`
  opacity: ${({ $show }) => ($show ? '1' : '0')};
`;

interface Props {
  isLoading: boolean | undefined;
  loaderColor?: loadingSpinnerColors;
  children: ReactNode;
}

/* To Keep the width of the button after switching from text to loader
 * we dont remove the text from the DOM just lowering the opacity
 * and overlapping it with the spinner */

const LoadingInner: FC<Props> = props => (
  <ContentWrapper>
    <SpinnerContainer $show={props.isLoading}>
      <LoadingSpinner size={10} color={props.loaderColor} />
    </SpinnerContainer>
    <TextContainer $show={!props.isLoading}>{props.children}</TextContainer>
  </ContentWrapper>
);

export default LoadingInner;
